package com.example.event_management_system.ui.theme

import androidx.compose.ui.graphics.Color

// Primary — Deep professional blue
val Primary = Color(0xFF1A56DB)
val OnPrimary = Color(0xFFFFFFFF)
val PrimaryContainer = Color(0xFFDBEAFF)
val OnPrimaryContainer = Color(0xFF001A45)

// Secondary — Neutral slate
val Secondary = Color(0xFF64748B)
val OnSecondary = Color(0xFFFFFFFF)
val SecondaryContainer = Color(0xFFE2E8F0)
val OnSecondaryContainer = Color(0xFF0F172A)

// Tertiary — Emerald accent
val Tertiary = Color(0xFF059669)
val OnTertiary = Color(0xFFFFFFFF)
val TertiaryContainer = Color(0xFFD1FAE5)
val OnTertiaryContainer = Color(0xFF022C22)

// Error colors
val Error = Color(0xFFDC2626)
val OnError = Color(0xFFFFFFFF)
val ErrorContainer = Color(0xFFFEE2E2)
val OnErrorContainer = Color(0xFF7F1D1D)

// Background & Surface
val Background = Color(0xFFF8FAFC)
val OnBackground = Color(0xFF0F172A)
val Surface = Color(0xFFFFFFFF)
val OnSurface = Color(0xFF0F172A)
val SurfaceVariant = Color(0xFFF1F5F9)
val OnSurfaceVariant = Color(0xFF475569)

// Surface containers (used by DropdownMenu, menus, tooltips, etc.)
val SurfaceContainer = Color(0xFFF1F5F9)
val SurfaceContainerLow = Color(0xFFF8FAFC)
val SurfaceContainerHigh = Color(0xFFE9EEF4)
val SurfaceContainerHighest = Color(0xFFE2E8F0)

// Outline
val Outline = Color(0xFF94A3B8)
val OutlineVariant = Color(0xFFE2E8F0)

// Event status background tints
val EventPending = Color(0xFFFFF7ED)
val EventConfirmed = Color(0xFFF0FDF4)
val EventCompleted = Color(0xFFEFF6FF)
val EventCancelled = Color(0xFFFFF1F2)

// Event status accent colors (solid indicators, dots, pills)
val EventPendingAccent   = Color(0xFFD97706)  // amber
val EventConfirmedAccent = Color(0xFF16A34A)  // green
val EventCompletedAccent = Color(0xFF2563EB)  // blue
val EventCancelledAccent = Color(0xFFDC2626)  // red

// Dark theme colors
val PrimaryDark = Color(0xFF93BBFC)
val OnPrimaryDark = Color(0xFF002676)
val PrimaryContainerDark = Color(0xFF1A3F8F)
val OnPrimaryContainerDark = Color(0xFFDBEAFF)

val SecondaryDark = Color(0xFF94A3B8)
val OnSecondaryDark = Color(0xFF1E293B)
val SecondaryContainerDark = Color(0xFF334155)
val OnSecondaryContainerDark = Color(0xFFE2E8F0)

val TertiaryDark = Color(0xFF34D399)
val OnTertiaryDark = Color(0xFF022C22)
val TertiaryContainerDark = Color(0xFF065F46)
val OnTertiaryContainerDark = Color(0xFFD1FAE5)

val ErrorDark = Color(0xFFFCA5A5)
val OnErrorDark = Color(0xFF7F1D1D)
val ErrorContainerDark = Color(0xFF991B1B)
val OnErrorContainerDark = Color(0xFFFEE2E2)

val BackgroundDark = Color(0xFF0F172A)
val OnBackgroundDark = Color(0xFFE2E8F0)
val SurfaceDark = Color(0xFF1E293B)
val OnSurfaceDark = Color(0xFFE2E8F0)
val SurfaceVariantDark = Color(0xFF334155)
val OnSurfaceVariantDark = Color(0xFF94A3B8)

val OutlineDark = Color(0xFF475569)
val OutlineVariantDark = Color(0xFF334155)

// Dark surface containers
val SurfaceContainerDark = Color(0xFF243249)
val SurfaceContainerLowDark = Color(0xFF1E293B)
val SurfaceContainerHighDark = Color(0xFF2D3E52)
val SurfaceContainerHighestDark = Color(0xFF334155)
